/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Tc_Generic_PlaceholderInputs */

const en_input_tc_generic_placeholder = /** @type {(inputs: Input_Tc_Generic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE Timecode`)
};

const fr_input_tc_generic_placeholder = /** @type {(inputs: Input_Tc_Generic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode SMPTE`)
};

const de_input_tc_generic_placeholder = /** @type {(inputs: Input_Tc_Generic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE-Zeitcode`)
};

const it_input_tc_generic_placeholder = /** @type {(inputs: Input_Tc_Generic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice temporale SMPTE`)
};

const ru_input_tc_generic_placeholder = /** @type {(inputs: Input_Tc_Generic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Временной код SMPTE`)
};

const es_input_tc_generic_placeholder = /** @type {(inputs: Input_Tc_Generic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de tiempo SMPTE`)
};

const zh_cn2_input_tc_generic_placeholder = /** @type {(inputs: Input_Tc_Generic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE 时间码`)
};

const ja_input_tc_generic_placeholder = /** @type {(inputs: Input_Tc_Generic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTEタイムコード`)
};

const hi_input_tc_generic_placeholder = /** @type {(inputs: Input_Tc_Generic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसएमपीटीई टाइमकोड`)
};

const pt_pt2_input_tc_generic_placeholder = /** @type {(inputs: Input_Tc_Generic_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de tempo SMPTE`)
};

/**
* | output |
* | --- |
* | "SMPTE Timecode" |
*
* @param {Input_Tc_Generic_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_tc_generic_placeholder = /** @type {((inputs?: Input_Tc_Generic_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Tc_Generic_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_tc_generic_placeholder(inputs)
	if (locale === "de") return de_input_tc_generic_placeholder(inputs)
	if (locale === "it") return it_input_tc_generic_placeholder(inputs)
	if (locale === "ru") return ru_input_tc_generic_placeholder(inputs)
	if (locale === "es") return es_input_tc_generic_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_input_tc_generic_placeholder(inputs)
	if (locale === "ja") return ja_input_tc_generic_placeholder(inputs)
	if (locale === "hi") return hi_input_tc_generic_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_input_tc_generic_placeholder(inputs)
	return en_input_tc_generic_placeholder(inputs)
});